/** 手机号脱敏：138****8000 */
export const maskPhone = (phone: string) => {
  return phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
};

/** 身份证脱敏：前 6 后 4（空值安全） */
export const maskIdCard = (idCard?: string | null) => {
  return idCard ? idCard.replace(/(\d{6})\d{8}(\d{4})/, '$1********$2') : '';
};
